import { createUseStyles } from 'react-jss'

export default createUseStyles({
  linkPreview: {
    lineBreak: 'anywhere'
  }
})
